import React from 'react';

import { ReactCountDataTableTitle } from '@metarouter-private/mr-mui';

import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';

const TITLE = {
  singular: 'Pipeline Tag',
  plural: 'Pipeline Tags',
};

export default function PipelineTagsTableTitle() {
  const { pagination } = usePipelineTagsTableContext();
  const count = pagination.count ?? 0;

  return <ReactCountDataTableTitle title={TITLE} count={count} />;
}
